module.exports = __webpack_public_path__ + "static/img/26826.f3824e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/dxsf/26826.png
// module id = yjhT
// module chunks = 0